"use strict";module.exports={"currentLocale":"en","isTestActive":function(e){return"ifit"===e?!0:process.browser&&"ifit"===window._d.lang?!0:!1}};